export default [
  {
    name: "Pepe Chicken By FastGoodCuisine - Commerce",
    plateform: "ubereats",
    address: "78 Rue De La Croix-Nivert, Paris, IDF 75015",
    tags: undefined,
    rate: "4.6",
    deliveryTime: 10,
    image: "/mock/image_0.png",
    status: "open",
    krunshScore: 96,
  },
  {
    name: "Tasty Crousty - Paris 18",
    plateform: "ubereats",
    address: "Tasty Crousty - Paris 18",
    tags: undefined,
    rate: "4.4",
    deliveryTime: 10,
    image: "/mock/image_1.png",
    status: "open",
    krunshScore: 90,
  },
  {
    name: "Five Pizza Original - Clichy",
    plateform: "ubereats",
    address: "99 Boulevard Jean Jaurès, Clichy, Île-de-France 92110",
    tags: undefined,
    rate: "4.5",
    deliveryTime: 15,
    image: "/mock/image_2.png",
    status: "open",
    krunshScore: 88,
  },
  {
    name: "Sushi Shop - Courcelles",
    plateform: "ubereats",
    address: "99 Boulevard Jean Jaurès, Clichy, Île-de-France 92110",
    tags: undefined,
    rate: "4.5",
    deliveryTime: 15,
    image: "/mock/image_3.png",
    status: "open",
    krunshScore: 79,
  },
  {
    name: "Peppe Pizzeria - Levallois",
    plateform: "deliveroo",
    address: "10 Rue Paul Vaillant-Couturier, Levallois-Perret, IDF 92300",
    tags: ["Italienne", "Pizzas", "Napolitaine", "Comfort Food"],
    rate: "4.7",
    deliveryTime: 12,
    image: "/mock/image_4.png",
    status: "open",
    krunshScore: 65,
  },
  {
    name: "Maurice Café - Ternes",
    plateform: "deliveroo",
    address: "237 Rue Du Faubourg Saint-Honoré, Paris, EMEA 75008",
    tags: undefined,
    rate: "4.3",
    deliveryTime: 10,
    image: "/mock/image_5.png",
    status: "open",
    krunshScore: 47,
  },
  {
    name: "Hélia",
    plateform: "deliveroo",
    address: "16 Rue Du Colisée, Paris, Île-de-France 75008",
    tags: undefined,
    rate: "4.7",
    deliveryTime: 10,
    image: "/mock/image_6.png",
    status: "open",
    krunshScore: 35,
  },
  {
    name: "Pokeshop Levallois",
    plateform: "deliveroo",
    address: "24 Rue Carnot, Levallois-Perret, IDF 92300",
    tags: undefined,
    rate: "4.5",
    deliveryTime: 10,
    image: "/mock/image_7.png",
    status: "open",
    krunshScore: 19,
  },
];
